import { WORKOUT_EXERCISE_KEY } from '@gymaholic/packages'
import { View } from 'components/View'
import memoize from 'memoize-one'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import SetRow from 'pages/Creator/SetRow'
import React, { memo } from 'react'
import Link from 'components/Link'
import {
  areEqual,
  FixedSizeList
} from 'react-window'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { getListWidthAppSelect } from 'modules/app/selectors/getListWidth/index.js'

const ListRow = memo(({
  data,
  index,
  style
}) => {
  const {
    items,
    handleClickSetType,
    handleClickSetValue,
    handleClickWeight,
    selectedRoundIndex,
    workoutSectionId,
    pathname,
    onClick,
    setIndex,
    isWorkoutScreen,
    isCreator,
    needsPremium
  } = data

  const renderSetRow = () => {
    return (
      <SetRow
        workoutExerciseId={getIdReduxUtil(items[selectedRoundIndex].combinedSetData[index])}
        setData={getValueReduxUtil(items[selectedRoundIndex].combinedSetData[index], WORKOUT_EXERCISE_KEY.SET_DATA)}
        handleClickSetValue={needsPremium ? null : () => handleClickSetValue(items[selectedRoundIndex].combinedSetData[index])}
        handleClickSetType={needsPremium ? null : () => handleClickSetType(items[selectedRoundIndex].combinedSetData[index])}
        handleClickWeight={needsPremium ? null : () => handleClickWeight(items[selectedRoundIndex].combinedSetData[index])}
        isSelected={isWorkoutScreen || Number(setIndex) === Number(index)}
        isWorkoutScreen={isWorkoutScreen}
      />
    )
  }

  let queryParams = `?workoutSectionId=${workoutSectionId}&workoutExerciseId=${getIdReduxUtil(items[selectedRoundIndex].combinedSetData[index])}&setIndex=${index}&roundIndex=${selectedRoundIndex}`
  if (isCreator) {
    queryParams = queryParams + '&isCreator=true'
  }

  if (workoutSectionId) {
    return (
      <View style={style}>
        <Link
          onClick={() => onClick(index)}
          to={`${pathname}${queryParams}`}
        >
          {renderSetRow()}
        </Link>
      </View>
    )
  }

  return (
    <View style={style}>
      {renderSetRow()}
    </View>
  )
}, areEqual)

const createItemData = memoize((items, handleClickSetType, handleClickSetValue, handleClickWeight, selectedRoundIndex, workoutSectionId, pathname, onClick, setIndex, isWorkoutScreen, isCreator, needsPremium) => ({
  items,
  handleClickSetType,
  handleClickSetValue,
  handleClickWeight,
  selectedRoundIndex,
  workoutSectionId,
  pathname,
  onClick,
  setIndex,
  isWorkoutScreen,
  isCreator,
  needsPremium
}))

function SetListRounds ({
  items,
  handleClickSetValue,
  handleClickSetType,
  handleClickWeight,
  selectedRoundIndex,
  workoutSectionId,
  pathname,
  onClick,
  setIndex,
  isWorkoutScreen,
  isCreator,
  needsPremium
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const itemData = createItemData(items, handleClickSetType, handleClickSetValue, handleClickWeight, selectedRoundIndex, workoutSectionId, pathname, onClick, setIndex, isWorkoutScreen, isCreator, needsPremium)
  const ref = React.useRef()
  const listWidth = useSelector(getListWidthAppSelect)

  const handleUpdate = () => {
    ref.current?.scrollToItem(0)
  }

  React.useEffect(() => {
    handleUpdate()
  }, [workoutSectionId])

  return (
    <View
      px={0.5}
      style={{
        alignItems: isSmallScreen ? 'unset' : 'center',
        boxSizing: 'border-box'
      }}
    >
      <FixedSizeList
        ref={ref}
        className='no-scrollbars'
        height={600}
        itemCount={items[selectedRoundIndex].combinedSetData.length}
        itemData={itemData}
        itemSize={115}
        width={isSmallScreen ? 'unset' : listWidth}
      >
        {ListRow}
      </FixedSizeList>
    </View>
  )
}

export default SetListRounds
